var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlmDadrkLogo = function SvgSlmDadrkLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.773 57.711"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1477"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1476"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1475"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1474"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#617482",
    stroke: "#617482",
    strokeWidth: 1.16,
    d: "M67.11 33.654a15.1 15.1 0 0 1-4.845-2.124 17.4 17.4 0 0 1-3.9-3.538 15.7 15.7 0 0 1-2.58-4.601 15.7 15.7 0 0 1-.92-5.379 15.6 15.6 0 0 1 1.274-6.264 16.7 16.7 0 0 1 3.433-5.131 16 16 0 0 1 5.093-3.469 15.6 15.6 0 0 1 6.267-1.27 26.5 26.5 0 0 1 8.883 1.486 26.2 26.2 0 0 1 7.609 4.176l-7.715 7.715a16.5 16.5 0 0 0-4.07-1.911 15.5 15.5 0 0 0-4.707-.708 5.2 5.2 0 0 0-3.822 1.557 5.2 5.2 0 0 0-1.557 3.822 5.53 5.53 0 0 0 1.274 3.463 5.9 5.9 0 0 0 3.185 1.84 27 27 0 0 0 3.964.566 17.7 17.7 0 0 1 6.122 1.345 15.5 15.5 0 0 1 4.919 3.22 15 15 0 0 1 3.256 4.813 15.5 15.5 0 0 1 1.2 6.193 15.6 15.6 0 0 1-1.274 6.264 16.05 16.05 0 0 1-8.529 8.529 15.6 15.6 0 0 1-6.264 1.274 26.2 26.2 0 0 1-10.189-1.979 26.9 26.9 0 0 1-8.352-5.45l7.573-7.574a16.1 16.1 0 0 0 4.99 3.185 15.8 15.8 0 0 0 5.981 1.132 5.11 5.11 0 0 0 3.756-1.558 5.2 5.2 0 0 0 1.553-3.82 5.8 5.8 0 0 0-.5-2.336 3.7 3.7 0 0 0-1.628-1.769 7.4 7.4 0 0 0-2.194-.814 21 21 0 0 0-2.477-.354l-2.544-.213a18 18 0 0 1-2.265-.318Zm34.4 21.871V1.878h10.686v42.888h19.535v10.759Zm75.238 0H165.21l-10.759-26.826v26.826h-10.686V1.878h11.537l15.713 39.212 15.641-39.212h11.537v53.647h-10.688V28.699Z",
    "data-name": "Group 1473"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1479"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#617482",
    "data-name": "Group 1478",
    transform: "translate(13.489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.085 2.542A2.542 2.542 0 1 1 2.543 0a2.54 2.54 0 0 1 2.542 2.542",
    "data-name": "Path 1302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.771.326H32.46v4.431H8.771z",
    "data-name": "Rectangle 1420"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.542,
    cy: 2.542,
    r: 2.542,
    "data-name": "Ellipse 37",
    transform: "translate(0 15.32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.222 20.077H8.762v-4.426h18.812",
    "data-name": "Path 1303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.085 10.232A2.542 2.542 0 1 1 2.543 7.69a2.54 2.54 0 0 1 2.542 2.542",
    "data-name": "Path 1304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.222 12.448H8.771V8.017h23.687",
    "data-name": "Path 1305"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f05b5b",
    d: "m0 32.202 29.651 25.509 19.241-28.945-.7-9.669L30.15 43.218 6.458 30.433",
    "data-name": "Path 1306"
  }))));
};
export default SvgSlmDadrkLogo;